// extracted by mini-css-extract-plugin
export default {"historyItemRow":"xyIBDPJi81R_MD8lfgFx","subscriptionNameCell":"f59KUA9Qfu4S30jLxwfe"};